export default __webpack_public_path__ + "static/media/bible.930dd99c.svg";